import React from 'react';

import HorizontalCardTiles from '../CardTileDesktop';
import CardTileMobile from 'page_modules/business-vac/components/CardTileMobile';

import styles from './__styles__/styles.scss?modules';

const CardTiles = ({ cardTileMobileProps, filteredCards }) => {
  return (
    <>
      <div className={styles.mobile}>
        <CardTileMobile {...cardTileMobileProps} filteredCards={filteredCards} />
      </div>
      <div className={styles['tablet-desktop']}>
        <HorizontalCardTiles filteredCards={filteredCards} />
      </div>
    </>
  );
};

export default CardTiles;
